import { FileText } from 'lucide-react';
import { useMemo } from 'react';
import { z } from 'zod';

import { BaseBadge } from './BaseBadge';
import { BaseToolBadgeProps } from './types';

// Accept both old format (target_file) and new format (file_id)
const ReadFileArgsSchema = z.object({
  explanation: z.string(),
  file_id: z.string().optional(),
  target_file: z.string().optional(),
});

export const ReadFileBadge = ({ isDone, ...props }: BaseToolBadgeProps) => {
  const allProps = { ...props, isDone };

  const args = useMemo(() => {
    return ReadFileArgsSchema.parse(props.args);
  }, [props.args]);

  // Get the file identifier (either format)
  const fileIdentifier = args.file_id || args.target_file || 'file';

  return (
    <BaseBadge
      {...allProps}
      showArgs={false}
      icon={FileText}
      resultTexts={{
        loading: 'Reading file...',
        done: `Read ${fileIdentifier}`,
        error: 'Error reading file',
      }}
    />
  );
};
